import {EmptyAlert} from '../EmptyAlert';
import {ErrorLoadingData} from '../ErrorLoadingData';
import {AddressData} from './AddressData';
import {AddressForm} from './AddressForm';
import {AddressFormV2} from './AddressFormV2';

const Address = {
	Data: AddressData,
	Form: AddressForm,
	FormV2: AddressFormV2,
	Empty: EmptyAlert,
	Error: ErrorLoadingData,
};

export {Address};
